import { z } from 'zod';

export const adminOverviewSchema = z.object({
  users_total: z.number(),
  tenant_admins_total: z.number(),
  challenges_total: z.number(),
  challenges_live: z.number(),
  leagues_total: z.number(),
  polls_total: z.number(),
  quizzes_total: z.number(),
  submissions_total: z.number(),
  purchases_total: z.number(),
});
export type AdminOverview = z.infer<typeof adminOverviewSchema>;
